import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const OnlineWorkshops = () => <EventCategoryPage config={EVENT_CATEGORIES['online-workshops']} data-id="element-9877" data-mp="3tnwkwufjmaiy" />;
export default OnlineWorkshops;